import React, { useState, useContext, useRef, useEffect } from 'react';
import WhiteCard from './WhiteCard';
import AppContext from '../api/AppContext';
import { FaKey, FaUsers, FaUserPlus, FaEdit, FaSave, FaTimes, FaTag } from 'react-icons/fa';

function InfoCamp({ associado }) {
  console.log("Associado InfoCamp:", associado);
  const { fetchDependentes, token } = useContext(AppContext);
  const [dependentes, setDependentes] = useState([]);
  const [mostrandoDependentes, setMostrandoDependentes] = useState(false);
  const [showModalUsuario, setShowModalUsuario] = useState(false);
  const [showModalTag, setShowModalTag] = useState(false);
  const [showModalTagUsuario, setShowModalTagUsuario] = useState(false);
  const [senhaUsuario, setSenhaUsuario] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [emailUsuario, setEmailUsuario] = useState('');
  const [tipoUsuario, setTipoUsuario] = useState('member');
  const [loading, setLoading] = useState(false);
  const [mensagem, setMensagem] = useState('');
  const [editando, setEditando] = useState(false);
  const [dadosEditados, setDadosEditados] = useState({});
  const [numeroTag, setNumeroTag] = useState('');
  const [numeroTagUsuario, setNumeroTagUsuario] = useState('');
  const [tagDoUsuario, setTagDoUsuario] = useState(''); // Estado para armazenar a tag do usuário
  const tagInputRef = useRef(null);
  const tagInputUsuarioRef = useRef(null);

  const APP_URL = 'https://app.olympicbarbacena.com.br';

  // Função para buscar a tag do usuário
  const buscarTagDoUsuario = async () => {
    try {
      const response = await fetch(`${APP_URL}/api/auth/check-user/${associado.CPF}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data)
        if (data.user && data.user.tag) {
          setTagDoUsuario(data.user.tag);
          return data.user.tag;
        }
      }
      return null;
    } catch (error) {
      console.error('Erro ao buscar tag do usuário:', error);
      return null;
    }
  };

  // Inicializa os dados editados quando o associado carrega e busca a tag do usuário
  useEffect(() => {
    if (associado) {
      setDadosEditados({
        EMAIL: associado.EMAIL || '',
        FONE1: associado.FONE1 || '',
        FONE2: associado.FONE2 || '',
        FONE3: associado.FONE3 || '',
        LOGRADOURO: associado.LOGRADOURO || '',
        NUMERO: associado.NUMERO || '',
        BAIRRO: associado.BAIRRO || '',
        CIDADE: associado.CIDADE || '',
        UF: associado.UF || '',
        CEP: associado.CEP || '',
        PROFISSAO: associado.PROFISSAO || '',
        TAG: associado.TAG || ''
      });

      // Busca a tag do usuário se o associado não tiver tag
      if (!associado.TAG) {
        buscarTagDoUsuario();
      }
    }
  }, [associado]);

  // Foca no input quando o modal de tag é aberto
  useEffect(() => {
    if (showModalTag && tagInputRef.current) {
      tagInputRef.current.focus();
    }
  }, [showModalTag]);

  // Foca no input quando o modal de tag do usuário é aberto
  useEffect(() => {
    if (showModalTagUsuario && tagInputUsuarioRef.current) {
      tagInputUsuarioRef.current.focus();
    }
  }, [showModalTagUsuario]);

  const handleVerDependentes = async () => {
    if (!mostrandoDependentes) {
      const resultado = await fetchDependentes(associado.ID);
      console.log("Dependentes encontrados:", resultado);
      setDependentes(resultado.data || []);
    }
    setMostrandoDependentes(!mostrandoDependentes);
  };

  // Função para gerar senha automática baseada no CPF e data de nascimento
  const gerarSenhaAutomatica = () => {
    const cpfLimpo = associado.CPF ? associado.CPF.replace(/\D/g, '') : '';
    const nascimentoLimpo = associado.NASCIMENTO ? 
      associado.NASCIMENTO.split('T')[0].replace(/\D/g, '') : '';
    
    if (cpfLimpo && nascimentoLimpo) {
      const senhaAuto = cpfLimpo + nascimentoLimpo;
      setSenhaUsuario(senhaAuto);
      setConfirmarSenha(senhaAuto);
    } else {
      setSenhaUsuario('');
      setConfirmarSenha('');
    }
  };

  // Abrir modal para criar usuário
  const handleCriarUsuario = () => {
    gerarSenhaAutomatica();
    setEmailUsuario(associado.EMAIL || '');
    setTipoUsuario('member');
    // Usa a tag do usuário se existir, senão usa a do associado
    setNumeroTagUsuario(tagDoUsuario || associado.TAG || '');
    setShowModalUsuario(true);
    setMensagem('');
  };

  // Criar usuário para o associado
  const criarUsuarioAssociado = async () => {
    if (!senhaUsuario) {
      setMensagem('A senha é obrigatória');
      return;
    }

    if (senhaUsuario.length < 8) {
      setMensagem('A senha deve ter pelo menos 8 caracteres');
      return;
    }

    if (senhaUsuario !== confirmarSenha) {
      setMensagem('As senhas não coincidem');
      return;
    }

    try {
      setLoading(true);
      setMensagem('');

      // Limpa o CPF - remove caracteres não numéricos
      const cpfLimpo = associado.CPF ? associado.CPF.replace(/\D/g, '') : '';

      console.log('Enviando para criação de usuário:', {
        name: associado.NOME,
        cpf: cpfLimpo,
        email: emailUsuario || null,
        role: tipoUsuario,
        associadoId: associado.ID,
        tag: numeroTagUsuario || null
      });

      const response = await fetch(`${APP_URL}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          name: associado.NOME,
          cpf: cpfLimpo,
          email: emailUsuario || null,
          role: tipoUsuario,
          password: senhaUsuario,
          passwordConfirm: confirmarSenha,
          associadoId: associado.ID,
          numeroTitulo: associado.TITULO,
          tag: numeroTagUsuario || null,
          dadosAssociado: {
            id: associado.ID,
            numero: associado.TITULO,
            titular: {
              nome: associado.NOME,
              cpf: cpfLimpo,
              nascimento: associado.NASCIMENTO
            },
            ATIVO: associado.ATIVO,
            BAIRRO: associado.BAIRRO,
            CEP: associado.CEP,
            CIDADE: associado.CIDADE,
            CODBARRAS: associado.CODBARRAS,
            CODFUNCIONARIO: associado.CODFUNCIONARIO,
            CODMUNICIPIO: associado.CODMUNICIPIO,
            CODTIPOSOCIO: associado.CODTIPOSOCIO,
            COMPLEMENTO: associado.COMPLEMENTO,
            CONVENIADO: associado.CONVENIADO,
            CONVENIADO_ADIMPLENTE: associado.CONVENIADO_ADIMPLENTE,
            COTA: associado.COTA,
            CPF: associado.CPF,
            DATA_DESATIVACAO: associado.DATA_DESATIVACAO,
            DIGITO: associado.DIGITO,
            DIRETORIA: associado.DIRETORIA,
            EMAIL: associado.EMAIL,
            ESTADOCIVIL: associado.ESTADOCIVIL,
            FACEBOOK: associado.FACEBOOK,
            FONE1: associado.FONE1,
            FONE2: associado.FONE2,
            FONE3: associado.FONE3,
            ID: associado.ID,
            IDENTIDADE: associado.IDENTIDADE,
            INCLUSAO: associado.INCLUSAO,
            LOGRADOURO: associado.LOGRADOURO,
            MAE: associado.MAE,
            NACIONALIDADE: associado.NACIONALIDADE,
            NASCIMENTO: associado.NASCIMENTO,
            NATURALIDADE: associado.NATURALIDADE,
            NOME: associado.NOME,
            NUMERO: associado.NUMERO,
            OBSERVACAO: associado.OBSERVACAO,
            PAI: associado.PAI,
            PROFISSAO: associado.PROFISSAO,
            SENHA: associado.SENHA,
            SEXO: associado.SEXO,
            TAG: numeroTagUsuario || associado.TAG || '',
            TITULO: associado.TITULO,
            UF: associado.UF,
            ULTIMA_ATUALIZACAO_CONVENIADO: associado.ULTIMA_ATUALIZACAO_CONVENIADO
          }
        })
      });

      const data = await response.json();

      if (response.ok) {
        setMensagem('Usuário criado com sucesso!');
        // Atualiza a tag localmente
        if (numeroTagUsuario) {
          setTagDoUsuario(numeroTagUsuario);
        }
        setTimeout(() => {
          setShowModalUsuario(false);
          setSenhaUsuario('');
          setConfirmarSenha('');
          setEmailUsuario('');
          setTipoUsuario('member');
          setNumeroTagUsuario('');
        }, 2000);
      } else {
        setMensagem(data.message || 'Erro ao criar usuário');
      }
    } catch (error) {
      console.error('Erro ao criar usuário:', error);
      setMensagem('Erro ao criar usuário');
    } finally {
      setLoading(false);
    }
  };

  // Função para salvar a tag no banco de dados do associado
  const salvarTagNoAssociado = async (tag) => {
    try {
      const response = await fetch(`${APP_URL}/api/auth/update-tag-by-cpf/${associado.CPF}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          tag: tag
        })
      });

      if (response.ok) {
        console.log('Tag salva no associado com sucesso');
        associado.TAG = tag;
      } else {
        console.error('Erro ao salvar tag no associado');
        throw new Error('Erro ao salvar tag');
      }
    } catch (error) {
      console.error('Erro ao salvar tag no associado:', error);
      throw error;
    }
  };

  // Funções para edição do associado
  const iniciarEdicao = () => {
    setEditando(true);
  };

  const cancelarEdicao = () => {
    setDadosEditados({
      EMAIL: associado.EMAIL || '',
      FONE1: associado.FONE1 || '',
      FONE2: associado.FONE2 || '',
      FONE3: associado.FONE3 || '',
      LOGRADOURO: associado.LOGRADOURO || '',
      NUMERO: associado.NUMERO || '',
      BAIRRO: associado.BAIRRO || '',
      CIDADE: associado.CIDADE || '',
      UF: associado.UF || '',
      CEP: associado.CEP || '',
      PROFISSAO: associado.PROFISSAO || '',
      TAG: associado.TAG || ''
    });
    setEditando(false);
  };

  const salvarEdicao = async () => {
    try {
      setLoading(true);
      
      const response = await fetch(`${APP_URL}/api/associados/${associado.ID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(dadosEditados)
      });

      if (response.ok) {
        setMensagem('Dados atualizados com sucesso!');
        setEditando(false);
        if (dadosEditados.TAG) {
          associado.TAG = dadosEditados.TAG;
        }
      } else {
        setMensagem('Erro ao atualizar dados');
      }
    } catch (error) {
      console.error('Erro ao salvar edição:', error);
      setMensagem('Erro ao salvar edição');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (campo, valor) => {
    setDadosEditados(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  // Funções para associar tag
  const abrirModalTag = () => {
    setNumeroTag(associado.TAG || tagDoUsuario || '');
    setShowModalTag(true);
  };

  const fecharModalTag = () => {
    setShowModalTag(false);
    setNumeroTag('');
  };

  const salvarTag = async () => {
    if (!numeroTag.trim()) {
      setMensagem('Por favor, informe o número da tag');
      return;
    }

    try {
      setLoading(true);
      setMensagem('');

      await salvarTagNoAssociado(numeroTag.trim());
      
      setDadosEditados(prev => ({
        ...prev,
        TAG: numeroTag.trim()
      }));
      
      setTagDoUsuario(numeroTag.trim());
      
      console.log('Tag salva:', numeroTag.trim(), 'para o associado:', associado.ID);
      
      setMensagem('Tag associada com sucesso!');
      setTimeout(() => {
        fecharModalTag();
      }, 2000);

    } catch (error) {
      console.error('Erro ao salvar tag:', error);
      setMensagem('Erro ao salvar tag');
    } finally {
      setLoading(false);
    }
  };

  // Funções para associar tag no modal de usuário
  const abrirModalTagUsuario = () => {
    setNumeroTag(numeroTagUsuario || '');
    setShowModalTagUsuario(true);
  };

  const fecharModalTagUsuario = () => {
    setShowModalTagUsuario(false);
  };

  const salvarTagUsuario = async () => {
    if (!numeroTag.trim()) {
      setMensagem('Por favor, informe o número da tag');
      return;
    }

    try {
      setLoading(true);
      setMensagem('');

      setNumeroTagUsuario(numeroTag.trim());
      
      console.log('Tag salva para usuário:', numeroTag.trim());
      
      setMensagem('Tag associada com sucesso!');
      setTimeout(() => {
        fecharModalTagUsuario();
      }, 2000);

    } catch (error) {
      console.error('Erro ao salvar tag:', error);
      setMensagem('Erro ao salvar tag');
    } finally {
      setLoading(false);
    }
  };

  // Função para obter a tag a ser exibida (prioriza a tag do associado, depois a do usuário)
  const getTagParaExibir = () => {
    return associado.TAG || tagDoUsuario || 'Não cadastrada';
  };

  // Verificar se o associado está ativo (baseado no campo ATIVO)
  const isAssociadoAtivo = associado.ATIVO && associado.ATIVO.trim() === 'S';

  return (
    <>
      <WhiteCard style={styles.card}>
        <div style={styles.cardHeader}>
          <strong style={styles.nome}>{associado.ID} - {associado.NOME}</strong>
          <div style={styles.headerActions}>
            <span style={styles.qrCode}>QR CODE</span>
            {!editando && (
              <button 
                onClick={iniciarEdicao}
                style={styles.editButton}
              >
                <FaEdit />
                Editar
              </button>
            )}
            {editando && (
              <button 
                onClick={abrirModalTag}
                style={styles.cadastrarTagButton}
              >
                <FaTag style={styles.buttonIcon} />
                Cadastrar Tag
              </button>
            )}
            {editando && (
              <button 
                onClick={cancelarEdicao}
                style={styles.cancelButtonSmall}
              >
                <FaTimes />
                Cancelar
              </button>
            )}
          </div>
        </div>

        <div style={styles.content}>
          <p style={styles.info}>Título: {associado.TITULO} / Dígito: {associado.DIGITO}</p>
          <p style={styles.info}>Ativo: {associado.ATIVO}</p>
          <p style={styles.info}>Saldo lanchonete: R$ 00,00</p>
          <p style={styles.info}>Tipo de cota: {associado.CODTIPOSOCIO}</p>
          <p style={styles.info}>CPF: {associado.CPF}</p>
          <p style={styles.info}>Nascimento: {Nascimento(associado.NASCIMENTO)}</p>

          <div style={styles.editavel}>
            <label style={styles.label}>E-mail:</label>
            {editando ? (
              <input
                type="email"
                value={dadosEditados.EMAIL}
                onChange={(e) => handleInputChange('EMAIL', e.target.value)}
                style={styles.input}
                placeholder="Digite o e-mail"
              />
            ) : (
              <p style={styles.info}>{associado.EMAIL || 'Não informado'}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Telefone 1:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.FONE1}
                onChange={(e) => handleInputChange('FONE1', e.target.value)}
                style={styles.input}
                placeholder="(00) 00000-0000"
              />
            ) : (
              <p style={styles.info}>{associado.FONE1 || 'Não informado'}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Telefone 2:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.FONE2}
                onChange={(e) => handleInputChange('FONE2', e.target.value)}
                style={styles.input}
                placeholder="(00) 00000-0000"
              />
            ) : (
              <p style={styles.info}>{associado.FONE2 || 'Não informado'}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Telefone 3:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.FONE3}
                onChange={(e) => handleInputChange('FONE3', e.target.value)}
                style={styles.input}
                placeholder="(00) 00000-0000"
              />
            ) : (
              <p style={styles.info}>{associado.FONE3 || 'Não informado'}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Endereço:</label>
            {editando ? (
              <div style={styles.enderecoContainer}>
                <input
                  type="text"
                  value={dadosEditados.LOGRADOURO}
                  onChange={(e) => handleInputChange('LOGRADOURO', e.target.value)}
                  style={styles.input}
                  placeholder="Logradouro"
                />
                <input
                  type="text"
                  value={dadosEditados.NUMERO}
                  onChange={(e) => handleInputChange('NUMERO', e.target.value)}
                  style={styles.inputNumero}
                  placeholder="Nº"
                />
              </div>
            ) : (
              <p style={styles.info}>{associado.LOGRADOURO}, {associado.NUMERO}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Bairro:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.BAIRRO}
                onChange={(e) => handleInputChange('BAIRRO', e.target.value)}
                style={styles.input}
                placeholder="Bairro"
              />
            ) : (
              <p style={styles.info}>{associado.BAIRRO}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Cidade/UF:</label>
            {editando ? (
              <div style={styles.cidadeContainer}>
                <input
                  type="text"
                  value={dadosEditados.CIDADE}
                  onChange={(e) => handleInputChange('CIDADE', e.target.value)}
                  style={styles.inputCidade}
                  placeholder="Cidade"
                />
                <input
                  type="text"
                  value={dadosEditados.UF}
                  onChange={(e) => handleInputChange('UF', e.target.value)}
                  style={styles.inputUF}
                  placeholder="UF"
                  maxLength="2"
                />
              </div>
            ) : (
              <p style={styles.info}>{associado.CIDADE} - {associado.UF}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>CEP:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.CEP}
                onChange={(e) => handleInputChange('CEP', e.target.value)}
                style={styles.input}
                placeholder="00000-000"
              />
            ) : (
              <p style={styles.info}>{associado.CEP}</p>
            )}
          </div>

          <div style={styles.editavel}>
            <label style={styles.label}>Profissão:</label>
            {editando ? (
              <input
                type="text"
                value={dadosEditados.PROFISSAO}
                onChange={(e) => handleInputChange('PROFISSAO', e.target.value)}
                style={styles.input}
                placeholder="Profissão"
              />
            ) : (
              <p style={styles.info}>{associado.PROFISSAO || 'Não informado'}</p>
            )}
          </div>

          {/* Campo TAG - sempre visível */}
          <div style={styles.editavel}>
            <label style={styles.label}>Tag:</label>
            {editando ? (
              <div style={styles.tagContainer}>
                <input
                  type="text"
                  value={dadosEditados.TAG || tagDoUsuario || ''}
                  onChange={(e) => handleInputChange('TAG', e.target.value)}
                  style={styles.input}
                  placeholder="Número da tag"
                />
                <button 
                  onClick={abrirModalTag}
                  style={styles.associarTagButton}
                  title="Ler tag automaticamente"
                >
                  <FaTag />
                </button>
              </div>
            ) : (
              <p style={styles.info}>{getTagParaExibir()}</p>
            )}
          </div>

          {editando && (
            <div style={styles.salvarContainer}>
              <button 
                onClick={salvarEdicao}
                style={styles.salvarButton}
                disabled={loading}
              >
                <FaSave style={styles.buttonIcon} />
                {loading ? ' Salvando...' : ' Salvar Alterações'}
              </button>
            </div>
          )}

          {!editando && (
            <div style={styles.buttonsContainer}>
              <button 
                onClick={handleVerDependentes} 
                style={styles.verDependentesButton}
              >
                <FaUsers style={styles.buttonIcon} />
                {mostrandoDependentes ? 'Ocultar Dependentes' : 'Ver Dependentes'}
              </button>

              {isAssociadoAtivo && (
                <button 
                  onClick={handleCriarUsuario}
                  style={styles.criarUsuarioButton}
                >
                  <FaUserPlus style={styles.buttonIcon} />
                  Criar Usuário
                </button>
              )}
            </div>
          )}

          {mostrandoDependentes && (
            <div>
              <h4 style={{ marginTop: '10px', fontWeight: 'bold' }}>Dependentes:</h4>
              {dependentes.length > 0 ? (
                dependentes.map((dep, index) => (
                  <div key={index} style={styles.dependenteItem}>
                    <p style={styles.info}>
                      <strong>{dep.NOME}</strong> — Digito: {dep.DIGITO} — 
                      Nascimento: {Nascimento(dep.NASCIMENTO)} — 
                      Parentesco: {dep.PARENTESCO}
                    </p>
                  </div>
                ))
              ) : (
                <p style={styles.info}>Nenhum dependente encontrado</p>
              )}
            </div>
          )}

          {mensagem && (
            <div style={mensagem.includes('sucesso') ? styles.mensagemSucesso : styles.mensagemErro}>
              {mensagem}
            </div>
          )}
        </div>
      </WhiteCard>

      {/* Modal para criação de usuário */}
      {showModalUsuario && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>Criar Usuário para {associado.NOME}</h3>
            
            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Nome:</label>
              <input 
                type="text" 
                value={associado.NOME} 
                readOnly 
                style={styles.modalInput}
              />
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>CPF:</label>
              <input 
                type="text" 
                value={associado.CPF} 
                readOnly 
                style={styles.modalInput}
              />
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>E-mail:</label>
              <input 
                type="email" 
                value={emailUsuario}
                onChange={(e) => setEmailUsuario(e.target.value)}
                style={styles.modalInputEditavel}
                placeholder="Digite o e-mail do usuário"
              />
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Tipo de Usuário:</label>
              <select
                value={tipoUsuario}
                onChange={(e) => setTipoUsuario(e.target.value)}
                style={styles.modalSelect}
              >
                <option value="member">Associado (Member)</option>
                <option value="staff">Colaborador (Staff)</option>
                <option value="finance">Financeiro</option>
                <option value="kitchen">Cozinha</option>
                <option value="snackbar">Lanchonete</option>
                <option value="admin">Administrador</option>
              </select>
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Tag:</label>
              <div style={styles.senhaContainer}>
                <input 
                  type="text" 
                  value={numeroTagUsuario} 
                  onChange={(e) => setNumeroTagUsuario(e.target.value)}
                  placeholder="Número da tag"
                  style={styles.modalInputEditavel}
                />
                <button 
                  onClick={abrirModalTagUsuario}
                  style={styles.autoSenhaButton}
                  title="Ler tag automaticamente"
                >
                  <FaTag />
                </button>
              </div>
              <small style={styles.senhaHint}>
                Aproxime a tag do leitor conectado ao computador
              </small>
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Senha:</label>
              <div style={styles.senhaContainer}>
                <input 
                  type="text" 
                  value={senhaUsuario} 
                  onChange={(e) => setSenhaUsuario(e.target.value)}
                  placeholder="Digite a senha ou use a automática"
                  style={styles.modalInputEditavel}
                />
                <button 
                  onClick={gerarSenhaAutomatica}
                  style={styles.autoSenhaButton}
                  title="Gerar senha automática (CPF + Data Nascimento)"
                >
                  Auto
                </button>
              </div>
              <small style={styles.senhaHint}>
                Senha automática: CPF + Data de Nascimento (apenas números)
              </small>
            </div>

            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Confirmar Senha:</label>
              <input 
                type="text" 
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                placeholder="Confirme a senha"
                style={styles.modalInputEditavel}
              />
            </div>

            {mensagem && (
              <div style={mensagem.includes('sucesso') ? styles.mensagemSucesso : styles.mensagemErro}>
                {mensagem}
              </div>
            )}

            <div style={styles.modalButtons}>
              <button 
                onClick={() => {
                  setShowModalUsuario(false);
                  setSenhaUsuario('');
                  setConfirmarSenha('');
                  setEmailUsuario('');
                  setTipoUsuario('member');
                  setNumeroTagUsuario('');
                  setMensagem('');
                }}
                style={styles.cancelButton}
                disabled={loading}
              >
                Cancelar
              </button>
              <button 
                onClick={criarUsuarioAssociado}
                style={styles.confirmButton}
                disabled={loading}
              >
                {loading ? 'Criando...' : 'Criar Usuário'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para associar tag (edição) */}
      {showModalTag && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>Associar Tag para {associado.NOME}</h3>
            
            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Número da Tag:</label>
              <input 
                ref={tagInputRef}
                type="text" 
                value={numeroTag}
                onChange={(e) => setNumeroTag(e.target.value)}
                style={styles.modalInputEditavel}
                placeholder="Aproxime a tag do leitor..."
                autoFocus
              />
              <small style={styles.senhaHint}>
                Aproxime a tag do leitor conectado ao computador
              </small>
            </div>

            {mensagem && (
              <div style={mensagem.includes('sucesso') ? styles.mensagemSucesso : styles.mensagemErro}>
                {mensagem}
              </div>
            )}

            <div style={styles.modalButtons}>
              <button 
                onClick={fecharModalTag}
                style={styles.cancelButton}
                disabled={loading}
              >
                Cancelar
              </button>
              <button 
                onClick={salvarTag}
                style={styles.confirmButton}
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar Tag'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para associar tag (criação de usuário) */}
      {showModalTagUsuario && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>Associar Tag para {associado.NOME}</h3>
            
            <div style={styles.modalField}>
              <label style={styles.modalLabel}>Número da Tag:</label>
              <input 
                ref={tagInputUsuarioRef}
                type="text" 
                value={numeroTag}
                onChange={(e) => setNumeroTag(e.target.value)}
                style={styles.modalInputEditavel}
                placeholder="Aproxime a tag do leitor..."
                autoFocus
              />
              <small style={styles.senhaHint}>
                Aproxime a tag do leitor conectado ao computador
              </small>
            </div>

            {mensagem && (
              <div style={mensagem.includes('sucesso') ? styles.mensagemSucesso : styles.mensagemErro}>
                {mensagem}
              </div>
            )}

            <div style={styles.modalButtons}>
              <button 
                onClick={fecharModalTagUsuario}
                style={styles.cancelButton}
                disabled={loading}
              >
                Cancelar
              </button>
              <button 
                onClick={salvarTagUsuario}
                style={styles.confirmButton}
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar Tag'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InfoCamp;

function Nascimento(data) {
  if (!data) return 'N/A';
  data = data.split('T')[0];
  const [ano, mes, dia] = data.split('-');
  return `${dia}/${mes}/${ano}`;
}

// 🎨 Estilos completos (mantenha os mesmos estilos do seu código original)
const styles = {
  // ... (mantenha todos os estilos do seu código original)
  card: {
    width: '100%',
    textAlign: 'left',
    marginBottom: '16px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e5e7eb',
  },
  nome: {
    color: '#111827',
    fontSize: '18px',
    fontWeight: '600',
    flex: 1,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  qrCode: {
    color: '#2563EB',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: '#EFF6FF',
    padding: '6px 12px',
    borderRadius: '6px',
    border: '1px solid #2563EB',
  },
  editButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#6B7280',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  cancelButtonSmall: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#DC2626',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  content: {
    textAlign: 'left',
  },
  editavel: {
    marginBottom: '12px',
  },
  label: {
    display: 'block',
    fontSize: '12px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '4px',
  },
  info: {
    margin: '4px 0',
    color: '#374151',
    fontSize: '14px',
    lineHeight: '1.4',
  },
  input: {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  tagContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  associarTagButton: {
    backgroundColor: '#dc7c38ff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '40px',
  },
  enderecoContainer: {
    display: 'flex',
    gap: '10px',
  },
  inputNumero: {
    width: '80px',
    padding: '8px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  cidadeContainer: {
    display: 'flex',
    gap: '10px',
  },
  inputCidade: {
    flex: 1,
    padding: '8px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  inputUF: {
    width: '60px',
    padding: '8px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  salvarContainer: {
    marginTop: '20px',
    textAlign: 'center',
  },
  salvarButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    backgroundColor: '#059669',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 24px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '600',
    margin: '0 auto',
  },
  buttonsContainer: {
    display: 'flex',
    gap: '12px',
    marginTop: '20px',
    flexWrap: 'wrap',
  },
  verDependentesButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#2563EB',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  criarUsuarioButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: '#059669',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    padding: '12px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  cadastrarTagButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    backgroundColor: '#dc7c38ff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '8px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  buttonIcon: {
    fontSize: '14px',
  },
  dependenteItem: {
    padding: '8px 0',
    borderBottom: '1px solid #E5E7EB',
  },
  mensagemSucesso: {
    backgroundColor: '#D1FAE5',
    color: '#065F46',
    padding: '12px',
    borderRadius: '6px',
    marginTop: '16px',
    fontSize: '14px',
    fontWeight: '500',
  },
  mensagemErro: {
    backgroundColor: '#FEE2E2',
    color: '#DC2626',
    padding: '12px',
    borderRadius: '6px',
    marginTop: '16px',
    fontSize: '14px',
    fontWeight: '500',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '12px',
    width: '90%',
    maxWidth: '500px',
    maxHeight: '90vh',
    overflowY: 'auto',
  },
  modalTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '20px',
    color: '#111827',
    textAlign: 'center',
  },
  modalField: {
    marginBottom: '16px',
  },
  modalLabel: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151',
    marginBottom: '6px',
  },
  modalInput: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    backgroundColor: '#F9FAFB',
    color: '#6B7280',
    boxSizing: 'border-box',
  },
  modalInputEditavel: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  modalSelect: {
    width: '100%',
    padding: '10px 12px',
    border: '1px solid #D1D5DB',
    borderRadius: '6px',
    fontSize: '14px',
    boxSizing: 'border-box',
    backgroundColor: 'white',
  },
  senhaContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  autoSenhaButton: {
    backgroundColor: '#dc7c38ff',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 12px',
    fontSize: '12px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    minWidth: '50px',
  },
  senhaHint: {
    color: '#6B7280',
    fontSize: '12px',
    marginTop: '4px',
    display: 'block',
  },
  modalButtons: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
    marginTop: '24px',
  },
  cancelButton: {
    backgroundColor: '#6B7280',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
  },
  confirmButton: {
    backgroundColor: '#059669',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    padding: '10px 20px',
    fontSize: '14px',
    cursor: 'pointer',
    fontWeight: '500',
  },
};